module.exports = __webpack_public_path__ + "img/hardshell_lateral_labelled.35943183.jpg";